'use client';

import { createContext } from 'react';

import type { CouponType } from '../../../../../schema/coupon/entry.js';

export type CouponIdContextType = {
  getType: () => CouponType | undefined;
  setType: (type: CouponType | undefined) => void;
};

/**
 * Coupon id context used to determine the active coupon id based on the current draw number and coupon type.
 *
 * The coupon type can actively be set by the user.
 */
export const CouponIdContext = createContext<CouponIdContextType | undefined>(undefined);
